// 全站的券包bag id
const couponBagId = '16'

/**
 * 判断是否为生产环境。
 *
 * 这个项目有点特殊和老。 process.env.REACT_APP_RUNTIME 这个配置没有生效， 暂时也不想去动这些配置。 所以保持和以前一样，使用域名来判断
 * @type {boolean}
 */
export const isProduction = window.isWeikeFeProduction

// 运行时环境
const runEnv = (() => {
  if (process.env.NODE_ENV === 'development') {
    // 一般是 localhost 的本地开发环境
    return 'development'
  }
  if (isProduction) {
    return 'production'
  }
  // 一般是测试环境
  return 'dbg'
})()

const globalWKLink = (() => {
  if (!window.WKLink || !window.WKLink.getApi) {
    return {}
  }
  const envToApi = {
    development: () => window.WKLink.getApi('lizhiweike.com', 'dev'),
    dbg: () => window.WKLink.getApi(window.window.location.hostname, 'dev'),
    // 生产环境的配置，不要随意变更。
    production: () => window.WKLink.getApi(window.location.hostname, 'prod'),
  }
  if (!envToApi[runEnv]) {
    return {}
  }
  return envToApi[runEnv]() || {}
})()

// 主站URL配置，优先使用globalWKLink中的配置，否则使用Session中的预设配置
const PRESET_MAIN_URL =
  globalWKLink.wk ||
  (window.Session &&
    window.Session.preset_config &&
    window.Session.preset_config.mainUrl)

// API基础URL配置，优先使用globalWKLink中的配置，否则使用Session中的预设配置
const PRESET_BASE_URL =
  globalWKLink.main ||
  (window.Session &&
    window.Session.preset_config &&
    window.Session.preset_config.baseUrl)

// 生产环境#api 请求
const prodApiConfig = {
  BASE_URL: PRESET_BASE_URL || 'https://apiv1.lizhiweike.com',
  WK_ADMIN_API: globalWKLink.admin || 'https://admin.lizhiweike.com',
  AUTH_URL: globalWKLink.open || 'https://open.lizhiweike.com',
  BASE_URL_ELSE: globalWKLink.apiGw || 'https://api-gw.lizhiweike.com',
  gateway_root_url:
    globalWKLink.gateway || 'https://gateway-weike.lizhiweike.com',
  BASE_CRM_API_URL: globalWKLink.matrix || 'https://matrix-proxy.goweike.cn',
  CRM_API_URL: `${globalWKLink.matrix ||
    'https://matrix-proxy.goweike.cn'}/__cms_wk`,
  WS_PUSH: `${globalWKLink.wsPush || 'https://push.lizhiweike.com'}/`,
  STAT: globalWKLink.stat || 'https://stat.lizhiweike.com',

  // 没有接入globalWKLink ，说明都是很老很老很老（可能都是废弃的服务了）
  MSG_API_URL: 'https://mapi.lycheer.cn',
  WARNING_URL: `https://weike.eva2.cn`,
  PGY_API_URL: 'https://api-pgy.lizhiweike.com',
}
// 生产环境#页面路径跳转
const prodPageConfig = {
  WK_PAGE_BASEURL: PRESET_MAIN_URL || 'https://m.lizhiweike.com',
  MAIN_URL: PRESET_MAIN_URL || 'https://m.lizhiweike.com',
  ADMIN_BASE_URL: globalWKLink.adminMain || 'https://admin.lizhiweike.com',
  WK_GW: globalWKLink.wkGw || 'https://www.lizhiweike.com',
  SHARE: globalWKLink.share || 'https://share.lizhiweike.com',

  // 没有接入globalWKLink ，说明都是很老很老很老（可能都是废弃的服务了）
  PGY_MALL_URL: 'https://pgy.lizhiweike.com',
}

// 生产环境# host 配置
export const prodConfig = {
  ...prodApiConfig,
  ...prodPageConfig,
  WXAPPID: 'wx3502aeb0c3639966',
  WXWEBAPPID: 'wx7e1cda3610d49884',
  WBWEBAPPID: '2828365896',
  ALIPAYAPPID: '2017081508206734',
  CLIENT_ID: 'weike_fe',
  REDIRECT_WARN: false,
  DEBUG: false,
  COUPON_BAG_ID: couponBagId,
}

// 测试环境#api 请求
const devApiConfig = {
  BASE_URL: PRESET_BASE_URL || `https://dbg.lizhiweike.com`,
  WK_ADMIN_API: globalWKLink.admin || `https://dev.admin.lizhiweike.com`,
  AUTH_URL: globalWKLink.open || 'https://dev.open.lizhiweike.com',
  BASE_URL_ELSE: globalWKLink.apiGw || `https://api.dev4.weike.fm`,
  gateway_root_url: globalWKLink.gateway || 'https://gateway.test.weike.fm',
  BASE_CRM_API_URL: globalWKLink.matrix || 'https://matrix-proxy.dev2.weike.fm',
  CRM_API_URL: `${globalWKLink.matrix ||
    'https://matrix-proxy.goweike.cn'}/__cms_wk`,
  WS_PUSH: `${globalWKLink.wsPush || 'https://dev.push.goweike.cn'}/socket.io`,
  STAT: globalWKLink.stat || 'https://stat.lizhiweike.com',

  // 没有接入globalWKLink ，说明都是很老很老很老（可能都是废弃的服务了）
  MSG_API_URL: 'https://mapi.lycheer.cn',
  WARNING_URL: `https://weike.eva2.cn`,
  PGY_API_URL: `https://api.dev.pgy.lizhiweike.com`,
}
// 测试环境#页面路径跳转
const devPageConfig = {
  WK_PAGE_BASEURL: PRESET_MAIN_URL || 'https://dbg.lizhiweike.com',
  MAIN_URL: PRESET_MAIN_URL || `https://dbg.lizhiweike.com`,
  ADMIN_BASE_URL: globalWKLink.adminMain || 'https://dbg.lizhiweike.com',
  WK_GW: globalWKLink.wkGw || 'https://www.lizhiweike.com',
  SHARE: globalWKLink.share || 'https://share.lizhiweike.com',

  // 没有接入globalWKLink ，说明都是很老很老很老（可能都是废弃的服务了）
  PGY_MALL_URL: `https://dev.pgy.lizhiweike.com`,
}

// 测试环境# host 配置
const devConfig = {
  ...devApiConfig,
  ...devPageConfig,
  WXAPPID: 'wxbafd424a88af8eb8',
  WXWEBAPPID: 'wx7e1cda3610d49884',
  WBWEBAPPID: '2828365896',
  ALIPAYAPPID: '2016081500252312',
  CLIENT_ID: 'weike_fe',
  REDIRECT_WARN: false,
  DEBUG: true,
  COUPON_BAG_ID: couponBagId,
}

if (!isProduction) {
  // 校验配置 （由于这个项目没有typescript , 所以在这里手动校验下配置）
  function validateKeys(configA, configB) {
    const keysA = Object.keys(configA)
    const keysB = Object.keys(configB)

    const onlyInA = keysA.filter(key => !keysB.includes(key))
    const onlyInB = keysB.filter(key => !keysA.includes(key))

    const hasDifference = onlyInA.length > 0 || onlyInB.length > 0

    if (hasDifference) {
      console.warn('【check config】发现不一致的键:')
      if (onlyInA.length > 0) {
        console.warn(
          `【check config】仅存在于第一个配置中的键: ${onlyInA.join(', ')}`,
        )
      }
      if (onlyInB.length > 0) {
        console.warn(
          `【check config】仅存在于第二个配置中的键: ${onlyInB.join(', ')}`,
        )
      }
    } else {
      console.log('【check config】两个配置的键完全一致')
    }

    return !hasDifference
  }

  validateKeys(prodConfig, devConfig)
}

export default isProduction ? prodConfig : devConfig

export const getMainHost = () => {
  if (prodPageConfig.MAIN_URL) {
    let newMainUrl = prodPageConfig.MAIN_URL
    newMainUrl = newMainUrl.replace('https://', '')
    newMainUrl = newMainUrl.replace('http://', '')
    return newMainUrl
  }

  return 'm.lizhiweike.com'
}



// WEBPACK FOOTER //
// ./src/config.js